import React from 'react';
import { Link } from 'react-router-dom';
import { Telescope, Map, Globe, Route, Lightbulb } from 'lucide-react';
import { motion } from 'framer-motion';

// Uygulamaların verilerini içeren bir dizi
const applications = [
    {
        id: 'mekanname-ai',
        title: 'Mekânname AI',
        description: 'Çektiğin fotoğraflardan tarihi mekânları tanır ve sana detaylı bilgi verir.',
        icon: <Telescope size={48} />,
        path: '/upload',
        gradient: 'from-blue-400 to-indigo-500'
    },
    {
        id: 'kesfet',
        title: 'Keşfet',
        description: 'Çevrendeki tarihi ve kültürel zenginlikleri interaktif harita üzerinde keşfet.',
        icon: <Map size={48} />,
        path: '/ankara',
        gradient: 'from-teal-400 to-cyan-500'
    },
    {
        id: 'sanal-tur',
        title: 'Sanal Tur',
        description: 'Tarihi mekânları evinin konforunda 360 derece sanal turlarla deneyimle.',
        icon: <Globe size={48} />,
        path: '/virtual-tour',
        gradient: 'from-amber-400 to-yellow-500'
    },
    {
        id: 'rotalar',
        title: 'Rotalar',
        description: 'Tarih, kültür ve doğa odaklı özel olarak hazırlanmış keşif rotalarını takip et.',
        icon: <Route size={48} />,
        path: '/route',
        gradient: 'from-fuchsia-400 to-purple-500'
    },
    {
        id: 'mekanname-quiz',
        title: 'Mekânname Quiz',
        description: 'Tarih bilginizi test edin, yeni şeyler öğrenin ve diğer kullanıcılarla yarışın.',
        icon: <Lightbulb size={48} />,
        path: '/quiz',
        gradient: 'from-green-400 to-lime-500'
    }
];

const ApplicationsPage = () => {
    return (
        <div className="relative min-h-screen bg-gray-800 text-white font-inter py-20 md:py-32 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.h1 
                    className="text-5xl md:text-6xl font-extrabold mb-4 bg-gradient-to-r from-teal-400 via-indigo-500 to-purple-500 bg-clip-text text-transparent drop-shadow-md"
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    Uygulamalarımız
                </motion.h1>
                <motion.p
                    className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-16"
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                >
                    Mekânname, tarihi ve kültürel keşif yolculuğunu zenginleştirmek için
                    çeşitli uygulamalar sunar.
                </motion.p>
                
                <div className="flex flex-col gap-16 md:gap-24">
                    {applications.map((app, index) => (
                        <motion.div
                            key={app.id}
                            className={`flex flex-col md:flex-row items-center gap-8 md:gap-16
                                ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
                            initial={{ 
                                opacity: 0, 
                                x: index % 2 === 0 ? -100 : 100 
                            }}
                            whileInView={{ 
                                opacity: 1, 
                                x: 0 
                            }}
                            viewport={{ 
                                once: true, 
                                amount: 0.3 
                            }}
                            transition={{ 
                                duration: 0.8, 
                                delay: index * 0.2 
                            }}
                        >
                            <div className={`flex-1 flex justify-center items-center p-6 md:p-10 rounded-3xl backdrop-blur-sm bg-gray-800/40 shadow-2xl`}>
                                <div className={`p-6 rounded-full bg-gradient-to-r ${app.gradient} text-white`}>
                                    {app.icon}
                                </div>
                            </div>
                            <div className={`flex-1 text-center md:text-left
                                ${index % 2 === 1 ? 'md:text-right' : ''}`}>
                                <h2 className={`text-4xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r ${app.gradient}`}>
                                    {app.title}
                                </h2>
                                <p className="text-gray-300 mb-6 text-lg">{app.description}</p>
                                <Link to={app.path} className={`inline-block`}>
                                    <motion.button
                                        whileHover={{ scale: 1.05, boxShadow: "0 0 12px #6366f1" }}
                                        className="px-8 py-4 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition-colors shadow-lg"
                                    >
                                        Keşfet
                                    </motion.button>
                                </Link>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ApplicationsPage;
